// extracted by mini-css-extract-plugin
export default {"main_heading":"VendorDashboard_main_heading__BCXGo","total":"VendorDashboard_total__KDfYj"};